const API_BASE = 'https://api.tianditu.gov.cn/api?v=4.0&tk='
const DEFAULT_KEY = 'decd51b2db1ba3fdbb4ced74967fd08f'
let loadPromise = null
let loadKey = null

function resolveKey(key) {
  return DEFAULT_KEY || key || process.env.VUE_APP_TIANDITU_KEY || ''
}

function ensureScript(key) {
  if (window.T) return Promise.resolve(window.T)
  if (loadPromise && loadKey === key) return loadPromise
  loadKey = key
  loadPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script')
    s.src = API_BASE + key
    s.async = true
    s.onload = () => {
      if (window.T) resolve(window.T)
      else reject(new Error('Tianditu namespace not available'))
    }
    s.onerror = () => reject(new Error('Tianditu script load failed'))
    document.head.appendChild(s)
  })
  return loadPromise
}

function getLngLatCtor() {
  if (!window.T) return null
  return window.T.LngLat || window.T.Lnglat || null
}

async function ready(key) {
  const tk = resolveKey(key)
  if (!tk) throw new Error('Tianditu key missing')
  return ensureScript(tk)
}

async function createMap(container, options = {}, key) {
  await ready(key)
  const el = typeof container === 'string' ? document.getElementById(container) : container
  const map = new window.T.Map(el)
  const ctor = getLngLatCtor()
  if (options.center && typeof options.zoom !== 'undefined' && ctor) {
    const center = new ctor(options.center.lng, options.center.lat)
    map.centerAndZoom(center, options.zoom)
  }
  if (Array.isArray(options.controls)) {
    options.controls.forEach(c => {
      if (c === 'zoom' && window.T.Control && window.T.Control.Zoom) map.addControl(new window.T.Control.Zoom())
      if (c === 'scale' && window.T.Control && window.T.Control.Scale) map.addControl(new window.T.Control.Scale())
      if (c === 'overview' && window.T.Control && window.T.Control.OverviewMap) map.addControl(new window.T.Control.OverviewMap())
    })
  }
  return map
}

function createLngLat(lng, lat) {
  const ctor = getLngLatCtor()
  if (!ctor) throw new Error('Tianditu not ready')
  return new ctor(lng, lat)
}

function addMarker(map, lng, lat, options = {}) {
  const point = createLngLat(lng, lat)
  const marker = new window.T.Marker(point, options)
  map.addOverLay(marker)
  return marker
}

export default {
  ready,
  createMap,
  createLngLat,
  addMarker
}
